module.exports = __webpack_public_path__ + "img/roorkee.28aa5a71.svg";